import type { IWebCOOSParsedGalleryService } from "@/services/assets/types"
import { useWebCOOSServiceMetadata } from "@/services/assets/useWebCOOSServiceMetadata"
import { ViewWithLoader } from "@axdspub/axiom-ui-utilities"
import type { ReactElement } from "react"

const DefaultElementView = ({ service }: { service: IWebCOOSParsedGalleryService }): ReactElement => {
    return <pre>{JSON.stringify(service, null, 2)}</pre>
}


const ServiceLoader = ({
    serviceIdentifier,
    View = DefaultElementView
}: {
    serviceIdentifier: string
    View: React.FC<{ service: IWebCOOSParsedGalleryService }>
}): ReactElement => {
    const { data, isLoading, error } = useWebCOOSServiceMetadata(serviceIdentifier)

    return <ViewWithLoader data={data} isLoading={isLoading} error={error}>
        {
            data &&
            <View service={data} />
        }

    </ViewWithLoader>

}

export default ServiceLoader